import { type AcceptItem } from '../../useQueryDeliveryNoteChainsAdmin';
import { type AcceptRoleCore, type AttachmentEnhanced } from '../types';

/**
 * Finds the accept state of a given role of a line item in the accepted items
 * of the delivery note and returns it for the given line item.
 * @param lineItemIndex - The index of the line item.
 * @param deliveryNote - The delivery note.
 * @param attachments - The attachments.
 * @param role - The role to get the accept state for.
 * @returns The accept state of the line item.
 */
export const getLineItemAcceptState = (
  lineItemIndex: number,
  acceptedItems: AcceptItem[],
  attachments: AttachmentEnhanced[] = [],
  role: AcceptRoleCore,
) => {
  const acceptInformation = acceptedItems.find(
    ({ acceptingParty, lineItemIndex: acceptedLineItemIndex }) => {
      return acceptedLineItemIndex === lineItemIndex && acceptingParty === role;
    },
  );

  // All accept state attachments are also stored in the attachments array
  // in a standardized and enriched format, so we can simply replace them.
  const acceptAttachments =
    acceptInformation?.attachments?.map((acceptAttachment) => {
      return (
        attachments.find(({ id }) => id === acceptAttachment?.blob?.digest) ??
        acceptAttachment
      );
    }) ?? [];

  return acceptInformation
    ? {
        ...acceptInformation,
        attachments: acceptAttachments,
      }
    : { attachments: acceptAttachments };
};
